/**
 * @author Nam Nguyen
 * @email nhn12.hoangnam@gmail.com
 * @desc Using Angular HttpClient for SignalR negotition request.
 * Reuse refresh token for SignalR.
 * Refresh token only affect for Websocket Transport.
 */
import * as AngularHttpClient from "@angular/common/http";
import { HttpClient, HttpRequest, HttpResponse } from "@aspnet/signalr";


export class SignalRHttpClient extends HttpClient {
	constructor(private http: AngularHttpClient.HttpClient) {
		super();
	}

	/**
	 * Handle for file stream via SignalR. Don't support at this time for this project.
	 */
	send(request: HttpRequest): Promise<HttpResponse> {
		return null;
	}

	/**
	 * Implement post for negotiation request.
	 */
	async post(url: string): Promise<HttpResponse> {
		return new Promise<HttpResponse>((resolve, reject) => {
			this.http.post(url, null, { observe: "response" }).subscribe(
				response => {
					resolve(
						new HttpResponse(
							response.status,
							response.statusText,
							JSON.stringify(response.body)
						)
					);
				},
				error => {
					reject(error);
				}
			);
		});
	}
}
